"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillEvaluation = exports.SkillProvisionLogs = exports.SkillProvisionStatus = exports.SkillProvisionBuildResponse = exports.SkillRef = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var SkillRef = /** @class */ (function () {
    function SkillRef(uri, client) {
        this.uri = uri;
        this.client = client;
    }
    SkillRef.prototype.start = function () {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.post({ uri: _this.uri }, '/skill/start'); });
    };
    SkillRef.prototype.stop = function () {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.post({ uri: _this.uri }, '/skill/stop'); });
    };
    SkillRef.prototype.logs = function (numberOfLines) {
        return this.logsInternal(numberOfLines)
            .pipe(operators_1.flatMap(function (response) { return rxjs_1.defer(function () { return response.logLines; }); }));
    };
    SkillRef.prototype.logsInternal = function (numberOfLines) {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.post({ uri: _this.uri, numberOfLines: numberOfLines }, '/skill/logs'); });
    };
    SkillRef.prototype.build = function () {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.post({ uri: _this.uri }, '/skill/build'); });
    };
    SkillRef.prototype.evaluate = function (first, second) {
        if (typeof first === 'string' && second !== undefined) {
            //corresponds to evaluate(contract, payload)
            return this.doEvaluate(first, second);
        }
        if (typeof first !== 'string' && second === undefined) {
            // corresponds to evaluate(payload)
            return this.doEvaluate(undefined, first);
        }
        throw new Error('Either use evaluate(contract:string, payload:{}) or evaluate(payload: {})');
    };
    SkillRef.prototype.doEvaluate = function (contract, p) {
        var _this = this;
        if (!p)
            throw new Error('You must provide a payload');
        var request = { uri: this.uri, payload: p };
        if (contract) {
            request['contract'] = contract;
        }
        return rxjs_1.defer(function () { return _this.client.post(request, '/skill/evaluate'); })
            .pipe(operators_1.map(function (r) { return new SkillEvaluation(r); }));
    };
    return SkillRef;
}());
exports.SkillRef = SkillRef;
var SkillProvisionBuildResponse = /** @class */ (function () {
    function SkillProvisionBuildResponse(reference) {
        this.reference = reference;
    }
    return SkillProvisionBuildResponse;
}());
exports.SkillProvisionBuildResponse = SkillProvisionBuildResponse;
var SkillProvisionStatus = /** @class */ (function () {
    function SkillProvisionStatus(name, status, createdAt) {
        this.name = name;
        this.status = status;
        this.createdAt = createdAt;
    }
    return SkillProvisionStatus;
}());
exports.SkillProvisionStatus = SkillProvisionStatus;
var SkillProvisionLogs = /** @class */ (function () {
    function SkillProvisionLogs(logLines) {
        this.logLines = logLines;
    }
    return SkillProvisionLogs;
}());
exports.SkillProvisionLogs = SkillProvisionLogs;
var SkillEvaluation = /** @class */ (function () {
    function SkillEvaluation(payload) {
        this.response = payload;
    }
    SkillEvaluation.prototype.response = function () {
        return this._response;
    };
    return SkillEvaluation;
}());
exports.SkillEvaluation = SkillEvaluation;
//# sourceMappingURL=SkillRef.js.map